declare var swal: any;
import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChange} from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';
//import { Chart } from '';

//import { ChartOptions, ChartType, ChartDataSets, Label} from 'chart.js';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SaveCounsellingActivityRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanController, CounsellingPlanRequest, CounsellingActivityController, CounsellingActivityRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, SaveCounsellingPlanRequest, MisReportCategoriesController, MisReportCategoriesRequest, MisReportDefByCategoryController, MisReportDefByCategoryRequest, BranchWiseRevenueController, BranchWiseRevenueRequest, BranchWiseRegistrationsController, BranchWiseRegistrationsRequest, BranchWiseRefundsController, BranchWiseRefundsRequest, BranchWiseVendorInvoiceController, BranchWiseVendorInvoiceRequest, BranchWiseDuesController, BranchWiseDuesRequest } from '../../../../../.././../src/app/ncs/models/actor/actor';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
//import { NgbActivityMonitoringModal } from './activitymonitoringmodal/activitymonitoring.modal';
import { timeInterval } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';
//import { isDefined } from '@ng-bootstrap/ng-bootstrap/util/util';
//import { NgbViewCounsellingPlanModal } from '../counsellingregistry/modal/viewcounsellingplan.modal';
//import { NgbCounsellingRegistryModal } from './modal/counsellingregistry.modal';
@Pipe({
    name: 'removeComma'
})
export class RemoveCommaPipe implements PipeTransform {

    transform(value: string): string {
        if (value !== undefined && value !== null) {
            return value.replace(/,/g, "");
        } else {
            return "";
        }
    }
}
@Component({
  selector: 'analysischarts',
    templateUrl: './analysischarts.component.html',
    styleUrls: ['./analysischarts.component.css']
})
export class AnalysisChartsComponent implements OnInit, OnChanges {
  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    if (this.CanLoadReport) {
      // alert('loading xy report..');
        this.LoadRevenue();
      //this.LoadReportsByCategory();

    }
   // alert(this.CanLoadReport);
   //// alert("called... xy change");
   // //  alert(this.ReportCategory);
   //// alert(changes[0].currentValue);
   //   var isChanged: SimpleChange = (changes["CanLoadReport"]);//as SimpleChange);
      
   // if ((isChanged != null)) {//&& isChanged.currentValue) {
   //     // alert(isChanged.
   //   //  this.CanLoadReport = true;
   //     if (this.CanLoadReport) {
   //      // alert('loading xy report..');
   //       this.LoadReportsByCategory();

   //     }
   //   }
   //   else {
   //     alert("load report false..");
   //    // this.CanLoadReport = false;
   //   }
     //   alert("XY CHART: " + this.FromDate);

  }
  @Input() CanLoadReport: boolean = false;
  @Input() ActorCode: number;
    @Input() FormattedCode: string;
    @Input() FromDate: Date;
    @Input() ToDate: Date;
    @Input() ReportCategory: string;
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
  ScheduleDate: NgbDateStruct;
  //public ActorCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public isRequesting: boolean = false;
  public BillingGraph: boolean = false;
  public LineGraph: boolean = false;
  public PieGraph: boolean = false;
  public Row1: boolean = true;
  public Row2: boolean = false;
    public Row3: boolean = false;
    public ReportType: string;
    public GraphData: boolean = false;
    public Row1samll: boolean = false;
    public GraphList: boolean = true;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;
    //public isRequesting: boolean = false;
  //@ViewChild('f') IdentitiesForm: NgForm;
  
 
  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  
    CurrentMisReportDefByCategoryController: MisReportDefByCategoryController[];
    CurrentMisReportDefByCategoryRequest: MisReportDefByCategoryRequest;

    LoadReportsByCategory() {
        this.CurrentMisReportDefByCategoryRequest = new MisReportDefByCategoryRequest();
      
        this.CurrentMisReportDefByCategoryRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetMisReportDefByCategoryController();
    }
    GetMisReportDefByCategoryController() {
        this.StartRefreshing();
        this.CurrentMisReportDefByCategoryRequest.ReportCategory = this.ReportCategory;
      this.CurrentMisReportDefByCategoryController = null;
        //alert(this.FormattedCode);
        this.actorservice.GetMisReportDefByCategoryController(this.CurrentMisReportDefByCategoryRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                  this.CurrentMisReportDefByCategoryController = this.ApiResData.Result;
                 // this.CanLoadReport = false;
                    //this.pdata = this.CurrentFollicularScansBetweenDateController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();

                }
                else {
                   this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                      this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentBranchWiseRevenueController: BranchWiseRevenueController[];
    CurrentBranchWiseRevenueRequest: BranchWiseRevenueRequest;



    LoadNext(n: number) {


        switch (n) {
            case 2:
                //this.LoadBranch..
                this.LoadRegistrations();
                break;
            case 3:
                //
                this.LoadRefunds();
                break;
            case 4:
                this.LoadVendorInvoice();
                break;
            case 5:
                this.LoadDues();
                break;
            default:
                break;


        };

    }


    LoadRevenue() {
        this.CurrentBranchWiseRevenueRequest = new BranchWiseRevenueRequest();
        this.CurrentBranchWiseRevenueRequest.FromDate = this.FromDate;
        this.CurrentBranchWiseRevenueRequest.ToDate = this.ToDate;
        this.CurrentBranchWiseRevenueRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetBranchWiseRevenueController();
    }
    GetBranchWiseRevenueController() {
        this.StartRefreshing();
        //this.CurrentMisReportDefByCategoryRequest.ReportCategory = this.ReportCategory;
        //this.CurrentMisReportDefByCategoryController = null;
        //alert(this.FormattedCode);
        this.actorservice.GetBranchWiseRevenueController(this.CurrentBranchWiseRevenueRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentBranchWiseRevenueController = this.ApiResData.Result;
                    // this.CanLoadReport = false;
                    //this.pdata = this.CurrentFollicularScansBetweenDateController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();
                    this.stopRefreshing();
                    this.LoadNext(2);
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentBranchWiseRegistrationsController: BranchWiseRegistrationsController[];
    CurrentBranchWiseRegistrationsRequest: BranchWiseRegistrationsRequest;
    LoadRegistrations() {
        this.CurrentBranchWiseRegistrationsRequest = new BranchWiseRegistrationsRequest();
        this.CurrentBranchWiseRegistrationsRequest.FromDate = this.FromDate;
        this.CurrentBranchWiseRegistrationsRequest.ToDate = this.ToDate;
        this.CurrentBranchWiseRegistrationsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetBranchWiseRegistrationsController();
    }
    GetBranchWiseRegistrationsController() {
        this.StartRefreshing();
        //this.CurrentMisReportDefByCategoryRequest.ReportCategory = this.ReportCategory;
        //this.CurrentMisReportDefByCategoryController = null;
        //alert(this.FormattedCode);
        this.actorservice.GetBranchWiseRegistrationsController(this.CurrentBranchWiseRegistrationsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentBranchWiseRegistrationsController = this.ApiResData.Result;
                    // this.CanLoadReport = false;
                    //this.pdata = this.CurrentFollicularScansBetweenDateController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();
                    this.stopRefreshing();
                    this.LoadNext(3);
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentBranchWiseRefundsController: BranchWiseRefundsController[];
    CurrentBranchWiseRefundsRequest: BranchWiseRefundsRequest;
    LoadRefunds() {
        this.CurrentBranchWiseRefundsRequest = new BranchWiseRefundsRequest();
        this.CurrentBranchWiseRefundsRequest.FromDate = this.FromDate;
        this.CurrentBranchWiseRefundsRequest.ToDate = this.ToDate;
        this.CurrentBranchWiseRefundsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetBranchWiseRefundsController();
    }
    GetBranchWiseRefundsController() {
        this.StartRefreshing();
        //this.CurrentMisReportDefByCategoryRequest.ReportCategory = this.ReportCategory;
        //this.CurrentMisReportDefByCategoryController = null;
        //alert(this.FormattedCode);
        this.actorservice.GetBranchWiseRefundsController(this.CurrentBranchWiseRefundsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentBranchWiseRefundsController = this.ApiResData.Result;
                    // this.CanLoadReport = false;
                    //this.pdata = this.CurrentFollicularScansBetweenDateController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();
                    this.stopRefreshing();
                    this.LoadNext(4);
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentBranchWiseVendorInvoiceController: BranchWiseVendorInvoiceController[];
    CurrentBranchWiseVendorInvoiceRequest: BranchWiseVendorInvoiceRequest;
    LoadVendorInvoice() {
        this.CurrentBranchWiseVendorInvoiceRequest = new BranchWiseVendorInvoiceRequest();
        this.CurrentBranchWiseVendorInvoiceRequest.FromDate = this.FromDate;
        this.CurrentBranchWiseVendorInvoiceRequest.ToDate = this.ToDate;
        this.CurrentBranchWiseVendorInvoiceRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetBranchWiseVendorInvoiceController();
    }
    GetBranchWiseVendorInvoiceController() {
        this.StartRefreshing();
        //this.CurrentMisReportDefByCategoryRequest.ReportCategory = this.ReportCategory;
        //this.CurrentMisReportDefByCategoryController = null;
        //alert(this.FormattedCode);
        this.actorservice.GetBranchWiseVendorInvoiceController(this.CurrentBranchWiseVendorInvoiceRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentBranchWiseVendorInvoiceController = this.ApiResData.Result;
                    // this.CanLoadReport = false;
                    //this.pdata = this.CurrentFollicularScansBetweenDateController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();
                    this.stopRefreshing();
                    this.LoadNext(5);
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentBranchWiseDuesController: BranchWiseDuesController[];
    CurrentBranchWiseDuesRequest: BranchWiseDuesRequest;
    LoadDues() {
        this.CurrentBranchWiseDuesRequest = new BranchWiseDuesRequest();
        this.CurrentBranchWiseDuesRequest.FromDate = this.FromDate;
        this.CurrentBranchWiseDuesRequest.ToDate = this.ToDate;
        this.CurrentBranchWiseDuesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetBranchWiseDuesController();
    }
    GetBranchWiseDuesController() {
        this.StartRefreshing();
        //this.CurrentMisReportDefByCategoryRequest.ReportCategory = this.ReportCategory;
        //this.CurrentMisReportDefByCategoryController = null;
        //alert(this.FormattedCode);
        this.actorservice.GetBranchWiseDuesController(this.CurrentBranchWiseDuesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentBranchWiseDuesController = this.ApiResData.Result;
                    // this.CanLoadReport = false;
                    //this.pdata = this.CurrentFollicularScansBetweenDateController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();
                    this.stopRefreshing();
                   // this.LoadNext(default);
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService,
    private loginservice: LoginService) { }
 
  ngOnInit() {
    
    //this.LoadPatients();
    //this.GetPatientInfoByFormattedCodeController();

    //  this.LoadReportsByCategory();
      //alert(this.ReportCategory);
      //alert(this.FromDate);
      //alert(this.ToDate);
     // this.LoadRevenue();
  }
  
 
  
  

  

  
 
  ///////////
  
  BackToCryoList() {
    this.router.navigate(['healins/ivffreezing']);
  }
  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }
  gotoviewprofile() {
    //alert(this.gotoviewprofile);
    this.router.navigate(['testnurse/profileview']);
  }
//AddPlan(){
//  const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
//    {
//      centered: true

//    })
//}
  //edit(l: CounsellingActivitiesByTimeController) {

  //  this.CurrentEditCounsellingActivityRequest.ActivityDate = l.ActivityDate;
  //  this.CurrentEditCounsellingActivityRequest.ActivityTime = l.ActivityTime;
  //  this.CurrentEditCounsellingActivityRequest.FollowupMode = l.FollowupMode;
  //  this.CurrentEditCounsellingActivityRequest.Followupstatus = l.FollowupStatus;
  //  this.CurrentEditCounsellingActivityRequest.Remarks = l.Remarks;
  //  this.CurrentEditCounsellingActivityRequest.PlanCode = l.PlanCode;
  //  this.CurrentEditCounsellingActivityRequest.ActualActivityDate = l.ActualActivityDate;
  //  this.CurrentEditCounsellingActivityRequest.ActualActivityTime = l.ActualActivityTime;
  //  this.CurrentEditCounsellingActivityRequest.ActorCode = l.ActorCode;
  //  this.CurrentEditCounsellingActivityRequest.CounsellingActivityCode = l.CounsellingActivityCode;
    
  //  const modalRef = this.modalService.open(NgbActivityMonitoringModal,
  //  {
  //  centered: true
  //    })
  //  modalRef.componentInstance.CurrentEditCounsellingActivityRequest = this.CurrentEditCounsellingActivityRequest;
  //  modalRef.componentInstance.ADate = l.ActivityDate;
  //  modalRef.componentInstance.Time = l.ActivityTime;
  //  //modalRef.componentInstance.ActivityTime = l.ActivityTime;
  //  //modalRef.componentInstance.ADate = l.ActivityDate;
  //  //modalRef.componentInstance.Time = l.ActivityTime;
  //  modalRef.componentInstance.Code = l.PlanCode;
  //  modalRef.componentInstance.Name = l.DisplayName;
  //  modalRef.result.then(x => { this.GetCounsellingActivitiesByTimeController() })
    
  //}

  //Viewplan() {
  //  this.CurrentEditCounsellingPlanRequest.Concerns = this.Selectedplan.Concerns;
  //  this.CurrentEditCounsellingPlanRequest.ActorCode = this.Selectedplan.ActorCode.toString();
  //  this.CurrentEditCounsellingPlanRequest.CounsellingDoctor = this.Selectedplan.CounsellingDoctor;
  //  this.CurrentEditCounsellingPlanRequest.CounsellingPlanCode = this.Selectedplan.CounsellingPlanCode;
  //  this.CurrentEditCounsellingPlanRequest.FinancialStatus = this.Selectedplan.FinancialStatus;
  //  this.CurrentEditCounsellingPlanRequest.PackageCost = this.Selectedplan.PackageCost;
  //  this.CurrentEditCounsellingPlanRequest.PlanStatus = this.Selectedplan.PlanStatus;
  //  this.CurrentEditCounsellingPlanRequest.Potential = this.Selectedplan.Potential;
  //  this.CurrentEditCounsellingPlanRequest.RecommendedPackage = this.Selectedplan.RecommendedPackage;
  //  this.CurrentEditCounsellingPlanRequest.SelectEmi = this.Selectedplan.SelectEmi;
  //  this.CurrentEditCounsellingPlanRequest.TreatmentPlan = this.Selectedplan.TreatmentPlan;
  //  this.CurrentEditCounsellingPlanRequest.VisitCode = this.Selectedplan.VisitCode.toString();
  //  this.CurrentEditCounsellingPlanRequest.EndDate = this.Selectedplan.EndDate;
  //  this.CurrentEditCounsellingPlanRequest.StartDate = this.Selectedplan.StartDate;
  //  const modalRef = this.modalService.open(NgbViewCounsellingPlanModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })
  //  modalRef.componentInstance.CurrentEditCounsellingPlanRequest = this.CurrentEditCounsellingPlanRequest;
  //  modalRef.componentInstance.FormattedCode = this.Selectedplan.FormattedCode;
  //  modalRef.componentInstance.FacilityName = this.Selectedplan.FacilityShortName;
  //  modalRef.result.then(x => { this.GetCounsellingPlanController() })
  //}

  viewBillGraph() {
    
    this.BillingGraph = true;
    this.LineGraph = false;
    this.PieGraph = false;
  }
  viewLineGraph() {

    this.BillingGraph = false;
    this.LineGraph = true;
    this.PieGraph = false;
  }
  viewPieGraph() {

    this.BillingGraph = false;
    this.LineGraph = false;
    this.PieGraph = true;
  }
  viewRow1() {
    this.Row2 = false;
    this.Row3 = false;
    this.Row1 = true;
  }
  viewRow2() {
    this.Row1 = false;
    this.Row3 = false;
    this.Row2 = true;
  }
  viewRow3() {
    this.Row1 = false;
    this.Row2 = false;
    this.Row3 = true;
    }
    viewRow1Small() {
        this.GraphList = false;
        this.GraphData = true;
        this.Row1samll = true;
        
    }
    BackTodashboard2() {
        this.GraphList = true;
        this.GraphData = false;
        this.Row1samll = false;
    }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
}

